document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("[data-accordion-toggle]").forEach((header) => {
    header.addEventListener("click", function () {
      const accordion = header.closest(".custom-accordion");
      const content = accordion.querySelector("[data-accordion-content]");
      const readMore = accordion.querySelector("[data-read-more]");
      const innerContent = content.querySelector(".accordion-inner-content");
      const maxHeight =
        content.getAttribute("data-description-height") || "300";
      const isOpen = accordion.classList.contains("open");

      if (isOpen) {
        // Collapse
        content.style.maxHeight = "0px";
        content.style.opacity = "0";
        accordion.classList.remove("open");
        // Remove fully-expanded class when closing
        accordion.classList.remove("fully-expanded");

        // Hide Read More
        if (readMore) {
          readMore.style.opacity = "0";
          readMore.textContent = readMore.dataset.textMore;
          readMore.setAttribute("data-expanded", "false");
        }
      } else {
        // Expand to initial height
        content.style.maxHeight = maxHeight + "px";
        content.style.opacity = "1";
        accordion.classList.add("open");
        // Don't add fully-expanded class here - content is not fully expanded yet

        // Show Read More
        if (readMore) {
          readMore.style.opacity = "1";
          readMore.textContent = readMore.dataset.textMore;
          readMore.setAttribute("data-expanded", "false");
        }
      }
    });
  });

  // Read More toggle
  document.querySelectorAll("[data-read-more]").forEach((button) => {
    button.addEventListener("click", function () {
      const accordion = button.closest(".custom-accordion");
      const content = accordion.querySelector("[data-accordion-content]");
      const innerContent = content.querySelector(".accordion-inner-content");
      const maxHeight =
        content.getAttribute("data-description-height") || "300";
      const isExpanded = button.getAttribute("data-expanded") === "true";

      if (isExpanded) {
        // Collapse to defined height
        content.style.maxHeight = maxHeight + "px";
        button.textContent = button.dataset.textMore;
        button.setAttribute("data-expanded", "false");
        // Remove fully-expanded class when collapsing
        accordion.classList.remove("fully-expanded");

        // ✅ Scroll to top of accordion with offset
        const yOffset = -200; // Add padding here
        const y =
          accordion.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: "smooth" });
      } else {
        // Expand fully
        content.style.maxHeight = innerContent.scrollHeight + "px";
        button.textContent = button.dataset.textLess;
        button.setAttribute("data-expanded", "true");
        // Add fully-expanded class when content is fully expanded
        accordion.classList.add("fully-expanded");
      }
    });
  });
});
